var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('span',[_vm._v("\n    COPYRIGHT @ "+_vm._s(new Date().getFullYear())+"\n    "),_c('a',{attrs:{"href":"#","target":"_blank","rel":"nofollow"}},[_vm._v("\n      SalusTech Integrated Database(SID)\n    ")]),_vm._v("\n    , All rights Reserved")])])
}
var staticRenderFns = []

export { render, staticRenderFns }